module.exports = __webpack_public_path__ + "img/approved.25c46c89.svg";